







































import { Component, Vue } from 'vue-property-decorator';
import { Modal, Button } from 'ant-design-vue';
import { namespace } from 'vuex-class';

const userModule = namespace('user');

@Component({
  components: {
    AModal: Modal,
    AButton: Button,
  },
})
export default class ClassName extends Vue {
  @userModule.Getter('getNoviceDialog') noviceData: any;

  @userModule.Getter('getGuideOptions') guideOptions: any;

  private isClosed: boolean = false;

  private get visible(): boolean {
    if (this.noviceData) {
      const nowTime: number = new Date().getTime();
      const { startTime, expireTime } = this.noviceData;
      return !this.isClosed && nowTime >= startTime && nowTime <= expireTime;
    }
    return false;
  }

  private get guideState(): boolean {
    if (this.guideOptions) {
      const { myClassAndType } = this.guideOptions;
      return myClassAndType && myClassAndType.isOption === 0;
    }
    return false;
  }

  // 点击关闭、我知道了
  private handleClose() {
    this.$service.common.saveOption({ id: this.noviceData.id }).then(() => {
      this.isClosed = true;
    });
  }
}
